export function normalizeTags(tagsValue) {
  if (!tagsValue) return [];
  if (Array.isArray(tagsValue)) return tagsValue;
  if (typeof tagsValue === "string") {
    const trimmed = tagsValue.trim();
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        // fall back to comma split
      }
    }
    return trimmed
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);
  }
  return [String(tagsValue)];
}